import * as React from 'react';

const MailFillSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        id="mail-fill_svg__eds-icon--mail-fill_svg"
        x={0}
        y={0}
        viewBox="0 0 24 24"
        xmlSpace="preserve"
        {...props}
    >
        <path
            id="mail-fill_svg__eds-icon--mail-fill_base"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 13.9L2 5.7V19h20V5.7l-10 8.2z"
        />
        <path
            id="mail-fill_svg__eds-icon--mail-fill_top"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.7 5l9.3 7.6L21.3 5z"
        />
    </svg>
);

MailFillSvg.displayName = 'MailFillSvg';
export default MailFillSvg;
